import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import StatusTooltip from 'modules/documents/components/DocumentPreview/Content/Esignature/StatusTooltip'
import StatusItem, {
  StatusStruct,
} from 'modules/documents/components/DocumentPreview/Content/StatusItem'
import type { EsignatureSignature } from 'modules/esignatures/hooks/signatures/useGetEsignatureSignatures'
import { SignatureStatuses } from 'modules/esignatures/lib/signatures/signatureStatuses'

interface Props {
  signature: EsignatureSignature
}

const toStatusStruct = (signature: EsignatureSignature): StatusStruct => {
  const status = signature.status as SignatureStatuses

  return {
    signerFullName: signature.signee.fullName,
    signerAvatar: signature.signee.avatar ? signature.signee.avatar : '',
    description: signature.data ? signature.data : '',
    statusText: getStatusText(status),
    statusDate: signature.registeredAt,
  }
}

const getStatusText = (status: SignatureStatuses): string => {
  return {
    [SignatureStatuses.Created]: i18n.t('documents.modal.esignature.status.sent'),
    [SignatureStatuses.Signed]: i18n.t('documents.modal.esignature.status.signed'),
    [SignatureStatuses.Declined]: i18n.t('documents.modal.esignature.status.declined'),
    [SignatureStatuses.Bounced]: i18n.t('documents.modal.esignature.status.sent'),
    [SignatureStatuses.Cancelled]: i18n.t('documents.modal.esignature.status.cancelled'),
  }[status]
}

const SignatureBox = ({ signature }: Props) => {
  return (
    <StatusItem
      status={toStatusStruct(signature)}
      statusBox={<StatusTooltip signature={signature} />}
    />
  )
}

export default SignatureBox
